import { AppState } from '../reducers/RootReducer'
import { createSelector } from 'reselect'
import { IPersonalProfile } from 'core/models/Models'

const getPersonalProfile = (state: AppState): IPersonalProfile => state.personalProfile.personalProfile

export const getPersonalProfileSelector = createSelector(
  getPersonalProfile,
  (personalProfile) => personalProfile,
)
